import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _03d5f689 = () => interopDefault(import('../pages/acerca-de/index.vue' /* webpackChunkName: "pages/acerca-de/index" */))
const _3c12e8d0 = () => interopDefault(import('../pages/blog/index.vue' /* webpackChunkName: "pages/blog/index" */))
const _21162866 = () => interopDefault(import('../pages/cajas/index.vue' /* webpackChunkName: "pages/cajas/index" */))
const _21a063bd = () => interopDefault(import('../pages/contacto/index.vue' /* webpackChunkName: "pages/contacto/index" */))
const _3b009f37 = () => interopDefault(import('../pages/contacto/index/empresa.vue' /* webpackChunkName: "pages/contacto/index/empresa" */))
const _d12e364c = () => interopDefault(import('../pages/contacto/index/persona.vue' /* webpackChunkName: "pages/contacto/index/persona" */))
const _3cc80cb4 = () => interopDefault(import('../pages/contacto/index/preguntas-frecuentes.vue' /* webpackChunkName: "pages/contacto/index/preguntas-frecuentes" */))
const _63562226 = () => interopDefault(import('../pages/eventos/index.vue' /* webpackChunkName: "pages/eventos/index" */))
const _7d8cb1c2 = () => interopDefault(import('../pages/gourmet/index.vue' /* webpackChunkName: "pages/gourmet/index" */))
const _7f5e3244 = () => interopDefault(import('../pages/iniciar-sesion.vue' /* webpackChunkName: "pages/iniciar-sesion" */))
const _e6c9e8ec = () => interopDefault(import('../pages/ofertas/index.vue' /* webpackChunkName: "pages/ofertas/index" */))
const _00b2b355 = () => interopDefault(import('../pages/recuperar-contrasena.vue' /* webpackChunkName: "pages/recuperar-contrasena" */))
const _40b5e2c4 = () => interopDefault(import('../pages/registro.vue' /* webpackChunkName: "pages/registro" */))
const _14786d54 = () => interopDefault(import('../pages/reiniciar-contrasena.vue' /* webpackChunkName: "pages/reiniciar-contrasena" */))
const _5b3b4c60 = () => interopDefault(import('../pages/reserva/index.vue' /* webpackChunkName: "pages/reserva/index" */))
const _1df320c9 = () => interopDefault(import('../pages/reserva-mesa/index.vue' /* webpackChunkName: "pages/reserva-mesa/index" */))
const _063f2351 = () => interopDefault(import('../pages/seguimiento/index.vue' /* webpackChunkName: "pages/seguimiento/index" */))
const _3507b4b9 = () => interopDefault(import('../pages/sommelier-virtual/index.vue' /* webpackChunkName: "pages/sommelier-virtual/index" */))
const _701ebc28 = () => interopDefault(import('../pages/vino-bar/index.vue' /* webpackChunkName: "pages/vino-bar/index" */))
const _01107d67 = () => interopDefault(import('../pages/vinos/index.vue' /* webpackChunkName: "pages/vinos/index" */))
const _645bcf6b = () => interopDefault(import('../pages/acerca-de/contacto/index.vue' /* webpackChunkName: "pages/acerca-de/contacto/index" */))
const _18b70636 = () => interopDefault(import('../pages/acerca-de/contacto/index/empresa.vue' /* webpackChunkName: "pages/acerca-de/contacto/index/empresa" */))
const _500cc288 = () => interopDefault(import('../pages/acerca-de/contacto/index/persona.vue' /* webpackChunkName: "pages/acerca-de/contacto/index/persona" */))
const _c369a3b6 = () => interopDefault(import('../pages/acerca-de/contacto/index/preguntas.vue' /* webpackChunkName: "pages/acerca-de/contacto/index/preguntas" */))
const _022856da = () => interopDefault(import('../pages/acerca-de/politicas-de-cambio.vue' /* webpackChunkName: "pages/acerca-de/politicas-de-cambio" */))
const _66b322fe = () => interopDefault(import('../pages/acerca-de/politicas-de-despacho.vue' /* webpackChunkName: "pages/acerca-de/politicas-de-despacho" */))
const _cfb9026e = () => interopDefault(import('../pages/acerca-de/politicas-de-privacidad.vue' /* webpackChunkName: "pages/acerca-de/politicas-de-privacidad" */))
const _d9baddce = () => interopDefault(import('../pages/contacto/gracias.vue' /* webpackChunkName: "pages/contacto/gracias" */))
const _9db91348 = () => interopDefault(import('../pages/cuenta/compras/index.vue' /* webpackChunkName: "pages/cuenta/compras/index" */))
const _728b4d80 = () => interopDefault(import('../pages/cuenta/mi-cuenta/index.vue' /* webpackChunkName: "pages/cuenta/mi-cuenta/index" */))
const _4ee8b434 = () => interopDefault(import('../pages/cuenta/mi-cuenta/index/compras.vue' /* webpackChunkName: "pages/cuenta/mi-cuenta/index/compras" */))
const _1d1aa5b6 = () => interopDefault(import('../pages/cuenta/mi-cuenta/index/mis-datos.vue' /* webpackChunkName: "pages/cuenta/mi-cuenta/index/mis-datos" */))
const _23762c19 = () => interopDefault(import('../pages/cuenta/mi-cuenta/index/mis-direcciones.vue' /* webpackChunkName: "pages/cuenta/mi-cuenta/index/mis-direcciones" */))
const _cf8ea454 = () => interopDefault(import('../pages/reserva-mesa/failed.vue' /* webpackChunkName: "pages/reserva-mesa/failed" */))
const _49e4d633 = () => interopDefault(import('../pages/reserva-mesa/thank-you.vue' /* webpackChunkName: "pages/reserva-mesa/thank-you" */))
const _0ddce2d9 = () => interopDefault(import('../pages/reserva/fallida.vue' /* webpackChunkName: "pages/reserva/fallida" */))
const _5cb44608 = () => interopDefault(import('../pages/reserva/gracias.vue' /* webpackChunkName: "pages/reserva/gracias" */))
const _43294151 = () => interopDefault(import('../pages/vinos/alcoholes.vue' /* webpackChunkName: "pages/vinos/alcoholes" */))
const _03c453f9 = () => interopDefault(import('../pages/vinos/busqueda.vue' /* webpackChunkName: "pages/vinos/busqueda" */))
const _fad94ae4 = () => interopDefault(import('../pages/cuenta/compras/politicas.vue' /* webpackChunkName: "pages/cuenta/compras/politicas" */))
const _a0584412 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _458dd846 = () => interopDefault(import('../pages/cuenta/compras/completa/_id.vue' /* webpackChunkName: "pages/cuenta/compras/completa/_id" */))
const _0955d900 = () => interopDefault(import('../pages/cuenta/compras/fallida/_id.vue' /* webpackChunkName: "pages/cuenta/compras/fallida/_id" */))
const _51296aae = () => interopDefault(import('../pages/blog/_article.vue' /* webpackChunkName: "pages/blog/_article" */))
const _f2b38b12 = () => interopDefault(import('../pages/eventos/_event.vue' /* webpackChunkName: "pages/eventos/_event" */))
const _4422be9a = () => interopDefault(import('../pages/orden/_id.vue' /* webpackChunkName: "pages/orden/_id" */))
const _76bdad57 = () => interopDefault(import('../pages/productos/_product.vue' /* webpackChunkName: "pages/productos/_product" */))
const _17c47b06 = () => interopDefault(import('../pages/vinos/_wine.vue' /* webpackChunkName: "pages/vinos/_wine" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/acerca-de",
    component: _03d5f689,
    name: "acerca-de___es"
  }, {
    path: "/blog",
    component: _3c12e8d0,
    name: "blog___es"
  }, {
    path: "/cajas",
    component: _21162866,
    name: "cajas___es"
  }, {
    path: "/contacto",
    component: _21a063bd,
    name: "contacto___es",
    children: [{
      path: "empresa",
      component: _3b009f37,
      name: "contacto-index-empresa___es"
    }, {
      path: "persona",
      component: _d12e364c,
      name: "contacto-index-persona___es"
    }, {
      path: "preguntas-frecuentes",
      component: _3cc80cb4,
      name: "contacto-index-preguntas-frecuentes___es"
    }]
  }, {
    path: "/eventos",
    component: _63562226,
    name: "eventos___es"
  }, {
    path: "/gourmet",
    component: _7d8cb1c2,
    name: "gourmet___es"
  }, {
    path: "/iniciar-sesion",
    component: _7f5e3244,
    name: "iniciar-sesion___es"
  }, {
    path: "/ofertas",
    component: _e6c9e8ec,
    name: "ofertas___es"
  }, {
    path: "/recuperar-contrasena",
    component: _00b2b355,
    name: "recuperar-contrasena___es"
  }, {
    path: "/registro",
    component: _40b5e2c4,
    name: "registro___es"
  }, {
    path: "/reiniciar-contrasena",
    component: _14786d54,
    name: "reiniciar-contrasena___es"
  }, {
    path: "/reserva",
    component: _5b3b4c60,
    name: "reserva___es"
  }, {
    path: "/reserva-mesa",
    component: _1df320c9,
    name: "reserva-mesa___es"
  }, {
    path: "/seguimiento",
    component: _063f2351,
    name: "seguimiento___es"
  }, {
    path: "/sommelier-virtual",
    component: _3507b4b9,
    name: "sommelier-virtual___es"
  }, {
    path: "/vino-bar",
    component: _701ebc28,
    name: "vino-bar___es"
  }, {
    path: "/vinos",
    component: _01107d67,
    name: "vinos___es"
  }, {
    path: "/acerca-de/contacto",
    component: _645bcf6b,
    name: "acerca-de-contacto___es",
    children: [{
      path: "empresa",
      component: _18b70636,
      name: "acerca-de-contacto-index-empresa___es"
    }, {
      path: "persona",
      component: _500cc288,
      name: "acerca-de-contacto-index-persona___es"
    }, {
      path: "preguntas",
      component: _c369a3b6,
      name: "acerca-de-contacto-index-preguntas___es"
    }]
  }, {
    path: "/acerca-de/politicas-de-cambio",
    component: _022856da,
    name: "acerca-de-politicas-de-cambio___es"
  }, {
    path: "/acerca-de/politicas-de-despacho",
    component: _66b322fe,
    name: "acerca-de-politicas-de-despacho___es"
  }, {
    path: "/acerca-de/politicas-de-privacidad",
    component: _cfb9026e,
    name: "acerca-de-politicas-de-privacidad___es"
  }, {
    path: "/contacto/gracias",
    component: _d9baddce,
    name: "contacto-gracias___es"
  }, {
    path: "/cuenta/compras",
    component: _9db91348,
    name: "cuenta-compras___es"
  }, {
    path: "/cuenta/mi-cuenta",
    component: _728b4d80,
    name: "cuenta-mi-cuenta___es",
    children: [{
      path: "compras",
      component: _4ee8b434,
      name: "cuenta-mi-cuenta-index-compras___es"
    }, {
      path: "mis-datos",
      component: _1d1aa5b6,
      name: "cuenta-mi-cuenta-index-mis-datos___es"
    }, {
      path: "mis-direcciones",
      component: _23762c19,
      name: "cuenta-mi-cuenta-index-mis-direcciones___es"
    }]
  }, {
    path: "/reserva-mesa/failed",
    component: _cf8ea454,
    name: "reserva-mesa-failed___es"
  }, {
    path: "/reserva-mesa/thank-you",
    component: _49e4d633,
    name: "reserva-mesa-thank-you___es"
  }, {
    path: "/reserva/fallida",
    component: _0ddce2d9,
    name: "reserva-fallida___es"
  }, {
    path: "/reserva/gracias",
    component: _5cb44608,
    name: "reserva-gracias___es"
  }, {
    path: "/vinos/alcoholes",
    component: _43294151,
    name: "vinos-alcoholes___es"
  }, {
    path: "/vinos/busqueda",
    component: _03c453f9,
    name: "vinos-busqueda___es"
  }, {
    path: "/cuenta/compras/politicas",
    component: _fad94ae4,
    name: "cuenta-compras-politicas___es"
  }, {
    path: "/",
    component: _a0584412,
    name: "index___es"
  }, {
    path: "/cuenta/compras/completa/:id?",
    component: _458dd846,
    name: "cuenta-compras-completa-id___es"
  }, {
    path: "/cuenta/compras/fallida/:id?",
    component: _0955d900,
    name: "cuenta-compras-fallida-id___es"
  }, {
    path: "/blog/:article",
    component: _51296aae,
    name: "blog-article___es"
  }, {
    path: "/eventos/:event",
    component: _f2b38b12,
    name: "eventos-event___es"
  }, {
    path: "/orden/:id?",
    component: _4422be9a,
    name: "orden-id___es"
  }, {
    path: "/productos/:product?",
    component: _76bdad57,
    name: "productos-product___es"
  }, {
    path: "/vinos/:wine",
    component: _17c47b06,
    name: "vinos-wine___es"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
